import { createInertiaApp, router } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createRoot } from "react-dom/client";
import "../css/app.css";
import "./bootstrap";
import ErrorBoundary from "./Components/ErrorBoundary";

const appName = "Patty Cariño";

// Ignorar errores benignos conocidos que llenan los logs de Microsoft Clarity / Sentry
window.addEventListener('error', (e) => {
    if (
        e.message === 'ResizeObserver loop limit exceeded' ||
        e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
        e.message === 'Node cannot be found in the current page' ||
        e.message === 'Script error.'
    ) {
        e.stopImmediatePropagation();
    }
});

// Scroll al top en cada navegación de Inertia
router.on("navigate", () => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
});

createInertiaApp({
    title: (title) => title || appName,
    resolve: (name) =>
        resolvePageComponent(
            `./Paginas/${name}.tsx`,
            import.meta.glob(["./Paginas/*.tsx", "./Paginas/**/*.tsx"])
        ),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <ErrorBoundary>
                <App {...props} />
            </ErrorBoundary>
        );
    },
    progress: {
        color: "#790546",
    },
});
